import { useQuery } from '@tanstack/react-query';

import { QUERY_DEFAULTS } from '@/shared/lib/constants/api';
import { experimentKeys } from '@/shared/lib/query/queryKeys';

import { compareRuns } from '@/entities/run/api/compareRunsApi';

export const useRunComparison = (runIds: number[]) => {
  return useQuery({
    queryKey: experimentKeys.runsComparison(runIds),
    queryFn: () => compareRuns({ runIds }),
    enabled: runIds.length > 0,
    staleTime: QUERY_DEFAULTS.STALE_TIME.MEDIUM,
    gcTime: QUERY_DEFAULTS.GC_TIME.MEDIUM,
  });
};
